import React, { useContext } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import clsx from "clsx";
import Contact from "./contact";
import Container from "@material-ui/core/Container";
import Copyright from "./copyright";
import Footermenu from "./footermenu";
import Logo from "./logo";
import Metamenu from "./metamenu";
import PageContext from "@PageContext";
import SocialLinks from "./socialLinks";
import WebProfileContext from "@WebProfileContext";

const useStyles = makeStyles((theme) => ({
	root: {
		background: theme.palette.background.footer,
		padding: theme.spacing(5, 3),
		[theme.breakpoints.up("lg")]: {
			padding: theme.spacing(7, 3, 5)
		}
	},
	containerFooter: {
		padding: theme.spacing(0)
	},
	logoWrapper: {
		display: "flex",
		justifyContent: "center"
	},
	addressWrapper: {
		color: theme.palette.common.white,
		lineHeight: "32px",
		margin: theme.spacing(8, 0),
		[theme.breakpoints.up("md")]: {
			display: "flex",
			justifyContent: "space-between"
		},
		[theme.breakpoints.up("lg")]: {
			flex: "1",
			margin: theme.spacing(2, 17, 8, 0)
		}
	},
	topWrapper: {
		[theme.breakpoints.up("lg")]: {
			display: "flex",
			flexWrap: "wrap",
			justifyContent: "space-between",
			marginTop: theme.spacing(10)
		}
	},
	bottomWrapper: {
		alignItems: "center",
		display: "flex",
		flexWrap: "wrap",
		[theme.breakpoints.up("lg")]: {
			justifyContent: "space-between"
		}
	},
	copyright: {
		flex: "1 0 175px",
		marginRight: "auto",
		[theme.breakpoints.up("lg")]: {
			flex: "unset",
			marginRight: theme.spacing(4),
			order: 1
		}
	},
	footermenu: {
		marginBottom: theme.spacing(8),
		[theme.breakpoints.up("lg")]: {
			flex: "0 0 287px"
		}
	},
	metamenu: {
		flex: "1 0 100%",
		marginTop: theme.spacing(3),
		[theme.breakpoints.up("lg")]: {
			flex: "unset",
			marginTop: theme.spacing(0),
			order: 2
		}
	},
	socialLinks: {
		[theme.breakpoints.up("lg")]: {
			order: 3
		}
	}
}));

const Footer = ({ addresses }) => {
	const [pageData] = useContext(PageContext);
	const [profileData] = useContext(WebProfileContext);
	const css = useStyles();

	const footermenu = pageData?.menuGroups.find((item) => item.title === "Footermenü");
	const metamenu = pageData?.menuGroups.find((item) => item.title === "Metamenü");
	const socialLinks = profileData?.links;

	return (
		<footer className={css.root}>
			<Container className={clsx("container-footer", css.containerFooter)} maxWidth="lg">
				<div className={clsx("logo-wrapper", css.logoWrapper)}>
					<Logo />
				</div>
				<div className={clsx("top-wrapper", css.topWrapper)}>
					<div className={clsx("address-wrapper", css.addressWrapper)}>
						<Contact data={addresses} />
					</div>
					{footermenu && (
						<div className={css.footermenu}>
							<Footermenu data={footermenu} />
						</div>
					)}
				</div>
				<div className={clsx("bottom-wrapper", css.bottomWrapper)}>
					<div className={css.copyright}>
						<Copyright />
					</div>
					{socialLinks && (
						<div className={css.socialLinks}>
							<SocialLinks data={socialLinks} />
						</div>
					)}
					{metamenu && (
						<div className={css.metamenu}>
							<Metamenu data={metamenu} />
						</div>
					)}
				</div>
			</Container>
		</footer>
	);
};

export default Footer;
